import {generateUniqueId} from "../../gd/utils/misc/generate-unique-id"
import Goal from "./goal"
import {GoalType} from "./const"
import GoalTask from "./item/goal-task"
import GoalProject from "./item/goal-project"
import GoalEvent from "./item/goal-event"

export default function goalFactory(data:any):Goal {
    // for locally created temporary goals
    if (!data.id) {
        data.id             = generateUniqueId()
        data.rootGoalId     = _.get(data.id, 'rootGoalId', data.id)
    }

    switch (data.type) {
        case GoalType.TASK      : return new GoalTask(data)
        case GoalType.PROJECT   : return new GoalProject(data)
        case GoalType.EVENT     : return new GoalEvent(data)

        default                 :
            return new Goal(data)
    }
}